import Vue from 'vue'
import colors from 'vuetify/es5/util/colors'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        primary: process.env.VUE_APP_PRIMARY_COLOR,
        secondary: colors.blue.accent3,
        accent: colors.blue.accent3,
        error: colors.red.darken1,
        success: colors.green.base,
        warning: colors.amber.base,
      },
      dark: {
        primary: process.env.VUE_APP_PRIMARY_COLOR,
        secondary: colors.blue.accent3,
        accent: colors.blue.accent3,
        error: colors.red.darken1,
        success: colors.green.base,
        warning: colors.amber.base,
      },
    },
  },
})
